import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Custom hook for retrieving the current page from the URL.
 *
 * @returns {number} - The current page number (default is 1).
 */
function usePage(): number {
	const [searchParams] = useSearchParams();
	return useMemo(() => Number(searchParams.get('page')) || 1, [searchParams]);
}

export default usePage;
